@for (alert of data$ | async; track trackById($index, alert)) {

  <div
    class="d-flex justify-between py-3 my-2  px-6 gap-3 text-white rounded" style="min-width:350px"
    [ngClass]="backgroundColor[alert.type]"
    >
    <div class="d-flex gap-3">
      @if (alert.type === 'info') {
        <mat-icon svgIcon="cp-info-icon"  class="stroke-none" />
      }
      @if (alert.type === 'success') {
        <mat-icon svgIcon="cp-check-icon--white" class="stroke-white" />
      }
      @if (alert.type === 'error') {
        <mat-icon svgIcon="cp-advice" fill="#000000" class="stroke-white" />
      }
      <span>{{ alert.message }}</span>
      @if (alert.link) {
        <span  class="ms-3" > <a class="text-nowrap text-white font-weight-bold" [routerLink]="alert.link.route">{{ alert.link.name }}</a></span>
      }
    </div>
    @if (alert.closeButton === true) {
      <mat-icon
        (click)="snackbarService.close(alert.id, alert.position)"
        class="stroke-white cursor-pointer"
        svgIcon="cp-close-icon"

        /> }
      </div>
    }
